<template>
    <form class="tw-space-y-5" data-test-id="user-notifications-form" @submit.prevent="onSubmit">
        <div>
            <l-select
                id="notificationChannel"
                :label="$t('profile.edit.labelNotifications')"
                :value.sync="form.notificationChannel"
                :disabled="hasAllFieldsDisabled"
                :options="notificationChannelSelectOptions"
                class="tw"
            />
        </div>

        <div>
            <l-select
                id="digestGoals"
                :label="$t('profile.edit.digestLabelGoals')"
                :value.sync="form.digest.goals"
                :disabled="hasAllFieldsDisabled"
                :options="digestGoalsSelectOptions"
                class="tw"
            />
        </div>

        <l-text-alert
            v-if="hasError"
            class="tw-leading-none tw-text-sm"
            type="danger"
            data-test-id="error"
            :text="errorMessage"
        />

        <l-base-button type="submit" :button-types="['default', 'raised']" :disabled="isLoading">
            {{ $t("profile.edit.btnUpdateDigest") }}
        </l-base-button>
    </form>
</template>

<script>
import { mapGetters } from "vuex";

import LSelect from "@/components/LSelect";
import LTextAlert from "@/components/LTextAlert";
import LBaseButton from "@/components/LBaseButton";

export default {
    components: { LSelect, LTextAlert, LBaseButton },
    data() {
        return {
            hasError: false,
            errorMessage: "",
            isLoading: false,
            form: {
                notificationChannel: "",
                digest: {
                    goals: "",
                },
            },
            notificationChannelSelectOptions: Object.freeze([
                {
                    text: this.$t("profile.edit.optionNotificationAll"),
                    value: "all",
                },
                {
                    text: this.$t("profile.edit.optionNotificationSlack"),
                    value: "slack",
                },
                {
                    text: this.$t("profile.edit.optionNotificationMsteams"),
                    value: "msteams",
                },
                {
                    text: this.$t("profile.edit.optionNotificationMail"),
                    value: "email",
                },
                {
                    text: this.$t("profile.edit.optionNotificationNone"),
                    value: "none",
                },
            ]),
            digestGoalsSelectOptions: Object.freeze([
                {
                    text: this.$t("profile.edit.optionDigestNever"),
                    value: "never",
                },
                {
                    text: this.$t("profile.edit.optionDigestDaily"),
                    value: "daily",
                },
                {
                    text: this.$t("profile.edit.optionDigestWeekly"),
                    value: "weekly",
                },
                {
                    text: this.$t("profile.edit.optionDigestBiWeekly"),
                    value: "biweekly",
                },
                {
                    text: this.$t("profile.edit.optionDigestMonthly"),
                    value: "monthly",
                },
            ]),
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
            rights: "users/current/rights",
        }),
        hasAllFieldsDisabled() {
            return this.isLoading;
        },
    },
    created() {
        this.prefillForm();
    },
    methods: {
        prefillForm() {
            Object.assign(this.form, {
                notificationChannel: this.currentUser.notificationChannel ?? "",
                digest: {
                    ...this.currentUser.digest,
                    goals: this.currentUser.digest?.goals ?? "",
                },
            });
        },
        async onSubmit() {
            this.isLoading = true;
            this.hasError = false;

            try {
                await this.$store.dispatch("users/current/updateProfile", {
                    payload: {
                        scope: ["digest", "notificationChannel"],
                        form: this.form,
                    },
                });

                this.prefillForm();
            } catch (err) {
                this.hasError = true;
                this.errorMessage = err.response?.data?.message ?? err.message;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
